import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useUser } from "../../contexts/user";
import { Helmet } from "react-helmet";
import Loader from "../loader/loader";
import { hasDashboardPermission } from "../../utils";
import useOrderPosition from "../../hooks/useOrderPosition";
import { ChooseUploadType } from "../../interfaces";

type Props = {
  title: string;
  exact: boolean;
  path: any;
  component: React.FC;
};

const PrivatePage: React.FC<Props> = ({ title, exact, path, component }) => {
  const [user] = useUser();
  const { positionImageAvailable } = useOrderPosition();

  return (
    <Loader full loading={!user || user.order.id === ""}>
      <Helmet>
        <title>{title || "Pixlip"}</title>
      </Helmet>
      {hasDashboardPermission(user?.user) ? (
        <Redirect to="/dashboard" />
      ) : user.order.id !== "not_found" ? (
        path === "/account/chooseUpload" ? (
          user.order.chooseUpload ? (
            positionImageAvailable() ? (
              user.order.chooseUpload === ChooseUploadType.bulkUpload ? (
                <Redirect to="/account/bulkupload" />
              ) : (
                <Redirect to="/account" />
              )
            ) : (
              <Route exact={exact} path={path} component={component} />
            )
          ) : positionImageAvailable() ? (
            <Redirect to="/account" />
          ) : (
            <Route exact={exact} path={path} component={component} />
          )
        ) : (
          <Route exact={exact} path={path} component={component} />
        )
      ) : (
        <Redirect to="/login" />
      )}
    </Loader>
  );
};

export default PrivatePage;
